import React from "react";

import { FiCheck } from "react-icons/fi";

const BankSuccessPage = ({
  continueAfterBankSuccess,
}) => {
  return (
    <section className="fw-screen fw-screen--bank-success fw-fade">
      <div className="fw-bank-success">
        <div
          className="fw-bank-success__icon-wrap"
          aria-hidden="true"
        >
          <span className="fw-bank-success__ring" />

          <span className="fw-bank-success__ring fw-bank-success__ring--2" />

          <span className="fw-bank-success__icon">
            <FiCheck />
          </span>
        </div>

        <h2 className="fw-bank-success__title">
          Success! tempd 
        </h2>

        <p className="fw-bank-success__msg">
          Your bank account has been linked successfully.
        </p>
      </div>

      <div className="fw-screen__footer">
        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          onClick={continueAfterBankSuccess}
        >
          Proceed
        </button>
      </div>
    </section>
  );
};

export default BankSuccessPage;